var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarIconUnfilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#CCCCCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_8265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14.3998H9.6C9.6 15.2638 10.696 15.9998 12 15.9998C13.304 15.9998 14.4 15.2638 14.4 14.3998C14.4 13.5198 13.568 13.1998 11.808 12.7758C10.112 12.3518 8 11.8238 8 9.5998C8 8.1678 9.176 6.9518 10.8 6.5438V4.7998H13.2V6.5438C14.824 6.9518 16 8.1678 16 9.5998H14.4C14.4 8.7358 13.304 7.9998 12 7.9998C10.696 7.9998 9.6 8.7358 9.6 9.5998C9.6 10.4798 10.432 10.7998 12.192 11.2238C13.888 11.6478 16 12.1758 16 14.3998C16 15.8318 14.824 17.0478 13.2 17.4558V19.1998H10.8V17.4558C9.176 17.0478 8 15.8318 8 14.3998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_8265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(2.3999 2.3999)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIconUnfilled);
export default __webpack_public_path__ + "static/media/dollar-icon-unfilled.35f907173b288df7959924e22a3a12da.svg";
export { ForwardRef as ReactComponent };